define(function (require) {

    window.lpTag = window.lpTag || {};

    var _ = require('underscore');
    var Chips = require('chips').default;
    var ViewController = require('web-agent-framework/ViewController');

    var QuickRepliesBubbleViewController = ViewController.extend({
        ControllerName: "QuickRepliesBubbleViewController",
        applicationType: "QuickRepliesBubbleViewController",
        templateFile: "LP_quick_replies_chat_bubble.html",

        LPViewMap: {
            bubble: '.lpview_quick_replies_bubble',
            contentPlaceholder: '.lpview_content_placeholder',
            actionMadeMessage: '.lpview_quick_replies_action_reported'
        },

        LPClassesMap: {
            quickRepliesBubble: 'quick_replies_chat_bubble',
            obsolete: 'obsolete',
            hidden: 'hidden'
        },

        initialize: function (constructorData) {
            this.convId = constructorData.convId;
            this.dialogId = constructorData.dialogId;
            this.lineData = constructorData.data;
            this.modelController = constructorData.modelController;
            this.chatsRootModelPath = constructorData.chatsRootModelPath;
            this.isHistory = constructorData.isHistory;
            this.consumerId = this.modelController.getModelParam(this.chatsRootModelPath + this.convId +'.visitorInfo.visitorId');

            if(this.lineData.originatorId !== this.consumerId) {
                this.chips = new Chips({
                    el: this.getFirstElement(this.LPViewMap.contentPlaceholder),
                    items: constructorData.quickReplies.replies,
                    rowSize: constructorData.quickReplies.itemsPerRow,
                    renderer: Chips.Renderer.StructuredContentButton
                });
                this.chips.readonly(true);
            }
        },

        events: function () {
            if(!this.isHistory && this.lineData.originatorId !== this.consumerId) {
                // bind to chat line 'action' (state) changes
                // if we already know the sequence id then bind to this chat line changes
                // else bind to any line state change:
                //      this allows us to check at a later time if this chat line sequence
                //      was populated and then bind to only this chat line changes
                if (typeof this.lineData.sequenceId !== 'undefined') {
                    this.bindModel({modelPath: this.lineActionModelPath(), callback: this.chatLineActionUpdate, context: this});
                }
                else {
                    this.bindModel({modelPath: this.lineStateModelPath(), callback: this.chatLineStateUpdate, context: this});
                }
            }
        },

        render:function () {
            var currentLineActionExists;
            if (this.lineData.originatorId !== this.consumerId) {
                // action is exposed on lineParticipantAction
                currentLineActionExists = this.lineData.lineParticipantAction && Object.keys(this.lineData.lineParticipantAction).length;
                if (this.isHistory || currentLineActionExists) {
                    this.renderQuickRepliesAsObsolete(currentLineActionExists);
                }
            }
        }
    });

    QuickRepliesBubbleViewController.prototype.chatLineStateUpdate = function(){
        // if this line sequence was already populated then bind to this chat line sequence action (state) changes
        if(typeof this.lineData.sequenceId !== 'undefined') {
            this.unbindModel({modelPath: this.lineStateModelPath(), callback: this.chatLineStateUpdate, context: this});
            this.bindModel({modelPath: this.lineActionModelPath(), callback: this.chatLineActionUpdate, context:this});
        }
    };

    QuickRepliesBubbleViewController.prototype.chatLineActionUpdate = function(data) {
        if(data.newValue && Object.keys(data.newValue).length) {
            this.unbindModel({modelPath: this.lineActionModelPath(), callback: this.chatLineActionUpdate, context:this});
            this.renderQuickRepliesAsObsolete(true);
        }
    };

    QuickRepliesBubbleViewController.prototype.renderQuickRepliesAsObsolete = function(buttonClicked) {
        var quickRepliesBubbleElement, actionMadeMessageElement;
        quickRepliesBubbleElement = this.getFirstElement(this.LPViewMap.contentPlaceholder, this);
        if (quickRepliesBubbleElement) {
            this.addClass(quickRepliesBubbleElement, this.LPClassesMap.obsolete);
        }

        if (buttonClicked) {
            actionMadeMessageElement = this.getFirstElement(this.LPViewMap.actionMadeMessage, this);
            if (actionMadeMessageElement) {
                this.removeClass(actionMadeMessageElement, this.LPClassesMap.hidden);
                this.viewEventsHandler.fireEvent({appName: this.convId, UIEvent: this.eventType.CONTENT_ADDED_TO_CONVERSATION, deleteOnFire: true});
            }
        }

        this.unbindModel({modelPath: this.lineStateModelPath(), callback: this.chatLineStateUpdate, context: this});
    };

    QuickRepliesBubbleViewController.prototype.dispose = function() {
        this.chips.dispose();
        ViewController.prototype.dispose.call(this);
    };

    QuickRepliesBubbleViewController.prototype.lineActionModelPath = function() {
        return this.chatsRootModelPath + this.convId + '.chatInfo.linesState.' + this.dialogId + ':' + this.lineData.sequenceId + '.lineParticipantAction';
    };

    QuickRepliesBubbleViewController.prototype.lineStateModelPath = function() {
        return this.chatsRootModelPath + this.convId + '.chatInfo.linesState';
    };

    return QuickRepliesBubbleViewController;
});
